var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsesV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ellipses-v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 3.75C9.9665 3.75 10.75 2.9665 10.75 2C10.75 1.0335 9.9665 0.25 9 0.25C8.0335 0.25 7.25 1.0335 7.25 2C7.25 2.9665 8.0335 3.75 9 3.75Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 3.75C16.9665 3.75 17.75 2.9665 17.75 2C17.75 1.0335 16.9665 0.25 16 0.25C15.0335 0.25 14.25 1.0335 14.25 2C14.25 2.9665 15.0335 3.75 16 3.75Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2 3.75C2.9665 3.75 3.75 2.9665 3.75 2C3.75 1.0335 2.9665 0.25 2 0.25C1.0335 0.25 0.25 1.0335 0.25 2C0.25 2.9665 1.0335 3.75 2 3.75Z",
    fill: "#94A3B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsesV);
export default __webpack_public_path__ + "static/media/ellipses-v.4b5791a9e26f1eef9ddcf540df2ba4b8.svg";
export { ForwardRef as ReactComponent };